import React from 'react';
import { RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer, Tooltip } from 'recharts';
import { CHART_COLORS } from '../../../../core/constants/financial';

// Mini-donut (anel radial) com o % no centro + tooltip no hover.
const ShareGauge = ({ percent, color, loading, size = 70, label = 'Percentual' }) => {
  const v = Math.min(100, Math.max(0, Number(percent) || 0));
  const data = [{ name: label, value: v }];

  return (
    <div className="dg-mini-donut" style={{ width: size, height: size }}>
      <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart innerRadius="72%" outerRadius="100%" data={data} startAngle={90} endAngle={-270}>
          <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
          <RadialBar
            background={{ fill: '#2c2c2c' }}
            dataKey="value"
            cornerRadius={8}
            fill={color}
            angleAxisId={0}
            isAnimationActive={!loading}
          />
          <Tooltip
            cursor={false}
            wrapperStyle={{ zIndex: 100 }}
            formatter={(value) => [`${Number(value).toFixed(0)}%`, label]}
            contentStyle={{ background: CHART_COLORS.tooltipBg, border: '1px solid #383838', borderRadius: 6, fontSize: 12 }}
            itemStyle={{ color: '#fff' }}
          />
        </RadialBarChart>
      </ResponsiveContainer>
      <span className="dg-mini-donut-pct">{loading ? '' : `${v.toFixed(0)}%`}</span>
    </div>
  );
};

export default ShareGauge;
